module.exports = __webpack_public_path__ + "static/media/marcas (5).50ac4cd2.jpg";